<ng-container *ngIf="show">
    <div class="disclaimer warning" role="alert">
        <a class="btn close" (click)="onCloseClick(dontShowAgain.checked)">Close</a>
        <h4>{{ disclaimer.title }}</h4>
        <p>
            {{ disclaimer.description }}
        </p>
        <mat-checkbox
            #dontShowAgain
            class="mb-3 mb-sm-0 me-sm-2 text-center text-sm-start"
        >
            <i>{{ disclaimer.dontShowAgain }}</i>
        </mat-checkbox>
    </div>
</ng-container>
